
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Booking() {
  const [selectedMethod, setSelectedMethod] = useState('');

  const bookingMethods = [
    {
      id: 'google',
      icon: 'ri-calendar-line',
      title: 'Googleカレンダー予約',
      description: '24時間いつでも予約可能',
      detail: '空き状況をリアルタイムで確認',
      color: 'from-blue-400 to-blue-500',
      url: 'https://calendar.app.google/gn28CuuTYSmjtmPt6'
    },
    {
      id: 'line',
      icon: 'ri-line-fill',
      title: 'LINE予約',
      description: 'お気軽にメッセージで予約',
      detail: 'デザイン相談も可能',
      color: 'from-green-400 to-green-500',
      url: 'https://line.me/R/ti/p/%40996pdhnp'
    },
    {
      id: 'instagram',
      icon: 'ri-instagram-line',
      title: 'Instagram DM',
      description: 'DMでご予約・お問い合わせ',
      detail: '最新デザインもチェック',
      color: 'from-pink-400 to-purple-500',
      url: 'https://instagram.com/nailsalonpuluchu'
    }
  ];

  const handleBookingClick = (method: any) => {
    if (method.id === 'google') {
      window.open(method.url, '_blank');
    } else if (method.id === 'instagram') {
      window.open(method.url, '_blank');
    } else if (method.id === 'line') {
      window.open(method.url, '_blank');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50">
      <Header />
      
      <main className="pt-20 pb-24">
        <div className="px-4">
          {/* ヒーローセクション */}
          <section className="text-center mb-8 animate-fade-in">
            <h1 className="text-3xl font-bold text-purple-800 mb-2" style={{ fontFamily: 'Pacifico, serif' }}>
              Booking
            </h1>
            <p className="text-gray-600 leading-relaxed">
              ご予約・お問い合わせ<br />
              お好きな方法でお気軽にどうぞ
            </p>
          </section>

          {/* 予約方法選択 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-purple-800 mb-6 text-center">
              予約方法を選択
            </h2>
            <div className="space-y-4">
              {bookingMethods.map((method, index) => (
                <div 
                  key={method.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105 animate-slide-in"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onClick={() => handleBookingClick(method)}
                >
                  <div className={`bg-gradient-to-r ${method.color} p-1`}>
                    <div className="bg-white rounded-xl p-4">
                      <div className="flex items-center space-x-4">
                        <div className={`w-16 h-16 bg-gradient-to-r ${method.color} rounded-full flex items-center justify-center flex-shrink-0`}>
                          <i className={`${method.icon} text-white text-2xl`}></i>
                        </div>
                        <div className="flex-1">
                          <h3 className="font-bold text-gray-800 mb-1 text-lg">
                            {method.title}
                          </h3>
                          <p className="text-gray-600 text-sm mb-1">
                            {method.description}
                          </p>
                          <p className="text-xs text-gray-500">
                            {method.detail}
                          </p>
                        </div>
                        <div className="text-gray-400">
                          <i className="ri-arrow-right-line text-xl"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* おすすめ予約方法 */}
          <section className="mb-8">
            <div className="bg-gradient-to-r from-blue-100 to-purple-100 rounded-2xl p-6">
              <div className="text-center mb-4">
                <i className="ri-star-fill text-yellow-500 text-2xl mb-2"></i>
                <h3 className="font-bold text-purple-800 text-lg">
                  おすすめ！Googleカレンダー予約
                </h3>
              </div>
              <div className="space-y-3 text-sm text-gray-700">
                <p className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  24時間いつでも予約可能
                </p>
                <p className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  リアルタイムで空き状況を確認
                </p>
                <p className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  予約確認メールが自動送信
                </p>
                <p className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  キャンセル・変更も簡単
                </p>
              </div>
              
              {/* 注意書きを追加 */}
              <p className="text-sm font-medium text-purple-600 text-center mt-4 px-2">
                <i className="ri-information-line mr-1 text-purple-500"></i>
                希望時間から２時間分の枠でご予約ください
              </p>
              
              <button 
                onClick={() => window.open('https://calendar.app.google/gn28CuuTYSmjtmPt6', '_blank')}
                className="w-full mt-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white py-3 rounded-xl font-semibold hover:from-blue-600 hover:to-purple-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <i className="ri-calendar-line mr-2"></i>
                今すぐ予約する
              </button>
            </div>
          </section>

          {/* 営業時間・注意事項 */}
          <section className="mb-8">
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <h3 className="font-bold text-purple-800 mb-4 flex items-center">
                <i className="ri-information-line mr-2"></i>
                ご予約前にご確認ください
              </h3>
              <div className="space-y-4 text-sm text-gray-700">
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                    <i className="ri-time-line text-purple-600 mr-2"></i>
                    営業時間
                  </h4>
                  <p className="ml-6">10:00 - 16:00（最終受付 15:00）</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                    <i className="ri-alert-line text-purple-600 mr-2"></i>
                    注意事項
                  </h4>
                  <div className="ml-6 space-y-1">
                    <p>• 完全予約制となっております</p>
                    <p>• キャンセルは前日までにご連絡ください</p>
                    <p>• 遅刻される場合は必ずご連絡ください</p>
                    <p>• お子様連れでのご来店も歓迎いたします</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* よくある質問 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-purple-800 mb-4 text-center">
              よくある質問
            </h2>
            <div className="space-y-3">
              {[
                {
                  question: '初回の方はどのくらい時間がかかりますか？',
                  answer: 'カウンセリング込みで通常より30分程度長くお時間をいただきます。'
                },
                {
                  question: '子供と一緒に行けますか？',
                  answer: 'はい、お子様連れ大歓迎です。キッズネイルもご用意しております。'
                },
                {
                  question: '駐車場はありますか？',
                  answer: 'はい、1台分の駐車場をご用意しております。'
                },
                {
                  question: 'デザインの持ち込みはできますか？',
                  answer: 'もちろんです。画像をお持ちいただければ可能な限り再現いたします。'
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white rounded-xl shadow-sm p-4 border border-pink-100">
                  <h4 className="font-semibold text-gray-800 mb-2 flex items-start">
                    <i className="ri-question-line text-purple-600 mr-2 mt-0.5 flex-shrink-0"></i>
                    {faq.question}
                  </h4>
                  <p className="text-sm text-gray-600 ml-6">{faq.answer}</p>
                </div>
              ))}
            </div>
          </section>

          {/* アクションボタン */}
          <section className="space-y-4">
            {/* 注意書きを追加 */}
            <p className="text-sm font-medium text-purple-600 text-center mb-4 px-2">
              <i className="ri-information-line mr-1 text-purple-500"></i>
              希望時間から２時間分の枠でご予約ください
            </p>
            
            <button 
              onClick={() => window.open('https://calendar.app.google/gn28CuuTYSmjtmPt6', '_blank')}
              className="w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white py-4 rounded-2xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              <i className="ri-calendar-line mr-2"></i>
              Googleカレンダーで予約
            </button>
            
            {/* Googleカレンダーボタンの下にも注意書きを追加 */}
            <p className="text-sm font-medium text-purple-600 text-center mb-4 px-2">
              <i className="ri-information-line mr-1 text-purple-500"></i>
              希望時間から２時間分の枠でご予約ください
            </p>
            
            <div className="grid grid-cols-2 gap-3">
              <button 
                onClick={() => window.open('https://instagram.com/nailsalonpuluchu', '_blank')}
                className="bg-gradient-to-r from-pink-400 to-purple-500 text-white py-3 rounded-xl font-medium hover:from-pink-500 hover:to-purple-600 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105"
              >
                <i className="ri-instagram-line mr-1 text-lg"></i>
                Instagram
              </button>
              <button 
                onClick={() => window.open('https://line.me/R/ti/p/%40996pdhnp', '_blank')}
                className="bg-gradient-to-r from-green-400 to-green-500 text-white py-3 rounded-xl font-medium hover:from-green-500 hover:to-green-600 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105"
              >
                <i className="ri-line-fill mr-1 text-lg"></i>
                LINE予約
              </button>
            </div>
          </section>
        </div>
      </main>

      {/* フッターの重複を削除 - Footerコンポーネントは1つだけ残す */}

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-in {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }

        .animate-slide-in {
          animation: slide-in 0.5s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
